<template>
  <img class="logo" src="~images/logo.png" />
</template>

<script>
export default {
  name: "Logo",
};
</script>

<style lang="less" scoped>
.logo {
  position: absolute;
  top: 0.45rem;
  left: 0.45rem;
  width: 2.44rem;
}
</style>